import React, {useState, useEffect} from 'react';
import { useNavigate } from 'react-router-dom';
import { helpHttp } from '../../helpers/helpHttp';
import { BASE_API } from '../../api/Globals';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { Button } from 'primereact/button';
import { Toolbar } from 'primereact/toolbar';
import { InputText } from 'primereact/inputtext';
import EditTienda from './edit';
import { storage } from '../../helpers/storage';

import Menu from '../../components/sturtural/Menu';

const ListaUsuarios = () => {
    const navigate = useNavigate();

    const [loading, setLoading] = useState(null);
    const [getTiendas, setTiendas] = useState(null);
    const [filters1, setFilters1] = useState(null);
    const [globalFilterValue1, setGlobalFilterValue1] = useState('');
    const [loadingSubmit, setLoadingSubmit] = useState({loading: false, id: 0});
    const [getEditModal, setEditModal] = useState(false);
    const [getTienda, setTienda] = useState(null);

    const perfil =  storage.get('perfilid');

    useEffect(() => {
        if(![1, 5, 9, 10, 11, 12].includes(parseInt(perfil))) {
            return navigate('/login');
        }
        initFilters1();
    }, [perfil]);

    let url = `${BASE_API}Usuarios/EjecutarTiendas`;

    useEffect(() => {
        setLoading(true);
        helpHttp().post(url, {
            body: {
                "opcion": "O",
                "IdTienda": 0,
                "Tienda": "",
                "Activo": true
            },
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Authorization': `Bearer ${storage.get('token')}`
            }
        }).then(res => {
            let jsonTiendas = res.ITEMS;
            
            if(jsonTiendas.length > 0) {
                
                setTiendas(jsonTiendas);
            } else {
                setTiendas(null);
            }
            setLoading(false);
        });
    }, [url]);

    const showStatus = (rowData) => {
        return (
            <>
                <button type="button" className="p-button p-component p-button-text p-button-icon-only" onClick={(e) => handleChamge_switch(rowData)}>
                    {(loadingSubmit.loading === true && loadingSubmit.id === rowData.IdTienda ? 
                        <span className={`p-button-icon p-c pi pi-spin pi-spinner`}></span>
                    :
                        <span className={`p-button-icon p-c pi ${(rowData.Activo === true ? 'pi-check-square' : 'pi-stop')}`}></span>
                    )}
                    <span className="p-button-label p-c">&nbsp;</span>
                    <span className="p-ink"></span>
                </button>
                <button type="button" className="p-button p-component p-button-text p-button-icon-only" onClick={(e) => handleChamge_form_edit(rowData)}>
                    <span className={`p-button-icon p-c pi pi-pencil`}></span>
                    <span className="p-button-label p-c">&nbsp;</span>
                    <span className="p-ink"></span>
                </button>
            </>
        );
    }

    const handleChamge_form_edit = (rowData) => {
        setTienda(rowData);
        setEditModal(true)
    }

    const handleChamge_switch = (rowData) => {
        setLoadingSubmit({loading: true, id:rowData.IdTienda});
        helpHttp().post(url, {
            body: {
                "opcion": "B",
                "IdTienda": rowData.IdTienda,
                "Tienda": "",
                "Activo": (rowData.Activo ? false : true)
            },
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Authorization': `Bearer ${storage.get('token')}`
            }
        }).then(res => {
            if(res.SUCCESS === true) {
                const updateData = {
                    IdTienda: rowData.IdTienda,
                    Tienda: rowData.Tienda,
                    Activo: (rowData.Activo ? false : true)
                }

                onComponentUpdate(updateData);
            } else {

            }
            setLoadingSubmit({loading: false, id: 0});
        });
    }

    const onComponentUpdate = (updateData) => {
        let newData = getTiendas.map((el) => 
            (el.IdTienda === updateData.IdTienda ? updateData : el)
        );
        setTiendas(newData);
    }

    const rightToolbarTemplate = () => {
        return (<Button label="Nueva tienda" icon="pi pi-plus" className="p-button-success mr-2" onClick={() => navigate('/configuracion/tienda/crear')} />)
    }

    const onGlobalFilterChange1 = (e) => {
        const value = e.target.value;

        let _filters1 = { ...filters1 };
        _filters1['global'].value = value;

        setFilters1(_filters1);
        setGlobalFilterValue1(value);
    }

    const renderHeader1 = () => {
        return (
            <div className="flex justify-content-between">
                <Button type="button" icon="pi pi-filter-slash" label="Limpiar" className="p-button-outlined" onClick={clearFilter1} />
                <span className="p-input-icon-left">
                    <i className="pi pi-search" />
                    <InputText value={globalFilterValue1} onChange={onGlobalFilterChange1} placeholder="Busqueda general" />
                </span>
            </div>
        )
    }

    const initFilters1 = () => {
        setFilters1({
            'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
            'Tienda': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] }
        });
        setGlobalFilterValue1('');
    }

    const clearFilter1 = () => {
        initFilters1();
    }

    const handleChamge_close_modal = () => {
        setEditModal(false);
    }

    const header1 = renderHeader1();

    return (
        <>
            <div>
                <Menu link='filtro' />

                <div className="col-12">
                    <div className="card">
                        <Toolbar className="mb-4" right={rightToolbarTemplate}></Toolbar>
                        <h5>TIENDA ({getTiendas?.length})</h5>
                        <DataTable 
                            value={getTiendas}  
                            className="p-datatable-gridlines" 
                            rows={50} 
                            showGridlines
                            paginator
                            filterDisplay="menu"
                            dataKey="IdTienda" 
                            loading={loading} 
                            responsiveLayout="scroll"
                            emptyMessage="No se encontraron tiendas."
                            filters={filters1}
                            header={header1}>

                            <Column field="Tienda" header="TIENDA:" />
                            <Column header="ACCIONES" body={showStatus} style={{textAlign: "center", minWidth: '5rem'}} />
                        </DataTable>
                    </div>
                </div>
            </div>

            <EditTienda visible={getEditModal} tienda={getTienda} close={handleChamge_close_modal} onComponentUpdate={onComponentUpdate} />
        </>      
    );
}

export default ListaUsuarios;